// src/components/battle/BattleCreateFab.jsx
import { useNavigate } from "react-router-dom";
import ListAddButton from "../common/ListAddButton";

export default function BattleCreateFab({ onCreate }) {
  const navigate = useNavigate();

  const handleClick = () => {
    if (onCreate) onCreate();
    else navigate("/battle/add");
  };

  return (
    <div
      className="
        fixed
        bottom-24 right-5   /* ✅ 우측하단 고정 (탭바 피해서 bottom-24) */
        z-50
      "
    >
      <ListAddButton onClick={handleClick} />
    </div>
  );
}
